import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Transition as _Transition, withCtx as _withCtx, createVNode as _createVNode, Teleport as _Teleport, createBlock as _createBlock } from "vue"

const _hoisted_1 = ["onClick"]
const _hoisted_2 = { class: "popup__header" }
const _hoisted_3 = { class: "popup__text" }
const _hoisted_4 = { class: "popup__buttons" }

import { onErrorCaptured } from 'vue';
  //  import { AppStore } from '@/stores/app';
    import { useI18n } from 'vue-i18n'

   // const appStore = AppStore();
    
export default /*#__PURE__*/_defineComponent({
  __name: 'ConfirmPopup',
  props: {
        show: {
            type: Boolean,
            default: false,
        },
        text: {
            type: String,
            default: 'cancel.text',
        },
        heading: {
            type: String,
            default: 'cancel.header',
        },
        okButton: {
            type: String,
            default: 'button.yes',
        },
        cancelButton: {
            type: String,
            default: 'button.no',
        }
    },
  emits: ['onAnswer'],
  setup(__props, { emit }) {

    /* imports */
    const { t } = useI18n();

    /* interface */


    /* Props */
    


    /* reactive */


    /* Emits */
    

    /* computed */

    /* functions */
    const doNothing = () => {
        return false;
    }
    const answer = (value: boolean) => {
        emit('onAnswer', value);
    }

    /* Lifecycle Hooks */
    onErrorCaptured(() => {
        emit('onAnswer', true);
    })

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_Teleport, { to: "body" }, [
    _createVNode(_Transition, {
      name: "popup",
      duration: 860
    }, {
      default: _withCtx(() => [
        (__props.show)
          ? (_openBlock(), _createElementBlock("div", {
              key: 0,
              class: "popup popup--confirm",
              onClick: _cache[2] || (_cache[2] = _withModifiers(($event: any) => (answer(false)), ["stop"]))
            }, [
              _createElementVNode("div", {
                class: "popup__content",
                onClick: _withModifiers(doNothing, ["stop","prevent"])
              }, [
                _createElementVNode("h2", _hoisted_2, _toDisplayString(_unref(t)(__props.heading)), 1),
                _createElementVNode("p", _hoisted_3, _toDisplayString(_unref(t)(__props.text)), 1),
                _createElementVNode("div", _hoisted_4, [
                  _createElementVNode("button", {
                    class: "btn btn--secondary",
                    onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (answer(false)), ["stop"]))
                  }, _toDisplayString(_unref(t)(__props.cancelButton)), 1),
                  _createElementVNode("button", {
                    class: "btn",
                    onClick: _cache[1] || (_cache[1] = _withModifiers(($event: any) => (answer(true)), ["stop"]))
                  }, _toDisplayString(_unref(t)(__props.okButton)), 1)
                ])
              ], 8, _hoisted_1)
            ]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    })
  ]))
}
}

})